//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { signIn } from "@/utils/auth.js";

export default {
  name: "SignInView",
  data() {
    return {
      valid: false,
      username: "",
      password: "",
      passwordVisible: false
    };
  },
  computed: {
    usernameRules() {
      return {
        required: value => !!value || "Obligatorio",
        regex: v => /^[0-9]{8,8}[A-Za-z]$/.test(v) || "El formato es incorrecto"
      };
    },
    passwordRules() {
      return {
        required: value => !!value || "Obligatorio",
        min: v => v.length >= 8 || "Mínimo 8 caracteres",
        emailMatch: () => "El usuario o contraseña no es correcto"
        //regex: v => /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{8,}$/.test(v) || "La contraseña debe tener 8 caracteres,"
      };
    }
  },
  methods: {
    submit() {
      this.username = this.username.toUpperCase();
      this.$refs.form.validate().then(async success => {
        if (success) {
          this.$q.loading.show();
          const result = await signIn(this.username, this.password);
          if (!result) {
            this.$q.notify({
              position: "top-right",
              message: "Usuario o contraseña incorrecta",
              color: "negative"
            });
          }
        } else {
          console.error(`Modelo no correcto`);
        }
      });
    }
  }
};
